import * as redeService from '@/store/rede/services'
import * as service from './services'
import to from 'await-to-js'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getExames ({dispatch, getters}, {idRede, name}) {
    const [error, response = { data: null }] = await to(redeService.getExamesByQuery(idRede, name))
    if (error) {
      throw error
    }
    return response.data
  },
  async getExamesFormBusca ({dispatch, getters}, q) {
    const [error, response = { data: null }] = await to(service.getExames(q))
    if (error) {
      throw error
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/exameRede/index.js